import { render, staticRenderFns } from "./CaixaEntradaTable.vue?vue&type=template&id=0d110023&scoped=true&lang=pug"
import script from "./CaixaEntradaTable.vue?vue&type=script&lang=js"
export * from "./CaixaEntradaTable.vue?vue&type=script&lang=js"
import style0 from "./CaixaEntradaTable.vue?vue&type=style&index=0&id=0d110023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d110023",
  null
  
)

export default component.exports